import React, {useState} from "react";
import {Button, Modal} from "antd";
import Editor from "@monaco-editor/react";
import {CheckCircleOutlined} from "@ant-design/icons";
import {usePermissions} from "react-admin";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCode} from "@fortawesome/free-solid-svg-icons";
import {ModalWidth} from "@src/components/Common/Variables"

const ModalWithButton = ({handleOk, buttonTitle, editorType, initialValue = {}}: {handleOk: Function, buttonTitle: string, editorType: string, initialValue?: any}) => {
    const { permissions } = usePermissions();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editorValue, setEditorValue] = useState(initialValue);
    const [errorMessage, setErrorMessage] = useState("");
    const openModal = () => {
        // Re-sync from the latest form value on every open so edits saved earlier
        // (or a remount of this component) never show a stale/empty editor
        setEditorValue(initialValue);
        setErrorMessage("");
        setIsModalOpen(true);
    };
    const handleOk_ = () => {
        if (editorType === "json") {
            // Allow clearing the field (empty/whitespace-only value)
            if (!editorValue || (typeof editorValue === "string" && !editorValue.trim())) {
                setErrorMessage("");
                setIsModalOpen(false);
                handleOk(null);
                return;
            }
            try {
                if(typeof editorValue === "string")
                    JSON.parse(editorValue)
                setErrorMessage("");
                setIsModalOpen(false);
                handleOk(editorValue);
            } catch (e) {
                setErrorMessage('Invalid JSON. Please enter valid JSON before submitting')
            }
        }
    };

    return <>
        {
            permissions === "ADMIN" &&
            <Button onClick={openModal} style={{lineHeight: 0}}>
                <FontAwesomeIcon icon={faCode} style={{ marginRight: 8 }} />
                {buttonTitle}
            </Button>
        }
        <Modal title={buttonTitle}
               open={isModalOpen}
               width={ModalWidth}
               onOk={handleOk_}
               footer={[
                   <Button key="back" onClick={() => setIsModalOpen(false)}>Cancel</Button>,
                   <Button key="submit" type="primary" onClick={handleOk_}>Save</Button>
               ]}
               closable={false}
        >
            <Editor
                height="50vh"
                defaultLanguage={editorType}
                value={typeof editorValue === "string" ? editorValue : JSON.stringify(editorValue, null, 4)}
                onChange={(value) => setEditorValue(value ?? "")}
                options={{formatOnPaste: true, minimap: {enabled: false}}}
            />
            {errorMessage && <div style={{ color: 'red', marginBottom: '10px' }}>{errorMessage}</div>}
        </Modal>
    </>

}

export default ModalWithButton;
